/* FNX-EMAIL-POPUP · 2026-10-19 · «15 % en tu primer pedido» (JS ligero, sin dependencias)
   Disparo: ~20 s de pestaña visible o exit intent (escritorio, puntero sale por arriba). Nunca al entrar.
   Silencio: 7 días tras cerrar o registrarse (localStorage fnxNl.v1 = {until: ms}).
   A11y: role=dialog + aria-modal, focus trap, Esc cierra, foco vuelve al elemento previo. */
(function () {
  'use strict';
  var root = document.getElementById('fnx-nl');
  if (!root) return;
  if (/\/(cart|checkouts?|account)(\/|$)/.test(location.pathname)) { root.remove(); return; }

  var KEY = 'fnxNl.v1';
  var DAY = 864e5;
  var days = parseInt(root.getAttribute('data-days'), 10) || 7;
  var delay = parseInt(root.getAttribute('data-delay'), 10) || 20000;
  var html = document.documentElement;
  var panel = root.querySelector('.fnx-nl-panel');
  var step1 = root.querySelector('[data-step="1"]');
  var step2 = root.querySelector('[data-step="2"]');
  var posted = root.querySelector('[data-fnx-nl-posted]');
  var mine = location.hash === '#fnx-nl-pop';           // el envío vino de ESTE formulario, no del footer
  var lastFocus = null, open = false, timer = null, elapsed = 0;

  function snooze() { try { localStorage.setItem(KEY, JSON.stringify({ until: Date.now() + days * DAY })); } catch (e) {} }
  function snoozed() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); return !!(v && v.until > Date.now()); } catch (e) { return false; }
  }

  // Umbral de envío gratis real del tema (NM.freeAt en centavos). Si no coincide con 1,999, se oculta la línea.
  var ship = root.querySelector('[data-fnx-nl-ship]');
  if (ship && window.NM && NM.freeAt && NM.freeAt !== 199900) ship.remove();

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; });
  }
  function onKey(e) {
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    else if (!panel.contains(document.activeElement)) { e.preventDefault(); a.focus(); }
  }

  function show(toStep2) {
    if (open) return;
    if (document.body.classList.contains('drawer-open') && !toStep2) return; // no encima del carrito
    open = true; stopTimers();
    lastFocus = document.activeElement;
    if (toStep2) { step1.hidden = true; step2.hidden = false; }
    root.hidden = false;
    html.classList.add('fnx-nl-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-in'); }); });
    document.addEventListener('keydown', onKey, true);
    setTimeout(function () {
      /* r19: no se enfoca el campo de correo al abrir (enfocarlo hace que Shopify descargue hCaptcha, ~760 KB); el foco va al botón de cerrar */ var t = toStep2 ? step2.querySelector('[data-fnx-nl-done]') : (root.querySelector('.fnx-nl-x') || root.querySelector('#fnx-nl-email'));
      if (t) t.focus({ preventScroll: true });
    }, 60);
  }
  function close() {
    if (!open) return;
    open = false; snooze();
    root.classList.remove('is-in');
    html.classList.remove('fnx-nl-open');
    document.removeEventListener('keydown', onKey, true);
    var done = function () { root.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || html.classList.contains('rm')) done();
    else setTimeout(done, 380);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-fnx-nl-close]'), function (b) { b.addEventListener('click', close); });

  // Al enviar: se marca el silencio de 7 días; el envío es el nativo de Shopify (form_type=customer).
  var form = root.querySelector('form');
  if (form) form.addEventListener('submit', function () { snooze(); });

  // Copiar código
  var copyBtn = root.querySelector('[data-fnx-nl-copy]');
  var codeEl = root.querySelector('[data-fnx-nl-code]');
  var copied = root.querySelector('[data-fnx-nl-copied]');
  if (copyBtn && codeEl) copyBtn.addEventListener('click', function () {
    var code = codeEl.textContent.trim();
    var ok = function () { copyBtn.textContent = 'Copiado'; if (copied) copied.textContent = 'Código copiado. Pégalo al pagar.'; };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, fallback);
    else fallback();
    function fallback() {
      var r = document.createRange(); r.selectNodeContents(codeEl);
      var s = getSelection(); s.removeAllRanges(); s.addRange(r);
      try { document.execCommand('copy'); ok(); } catch (e) {}
    }
  });

  // Regreso del envío: abrir directo (código o error), sin esperar ni respetar el silencio.
  if (mine && posted) {
    if (posted.getAttribute('data-fnx-nl-posted') === 'ok') { snooze(); show(true); }
    else show(false);
    return;
  }
  if (snoozed()) { root.remove(); return; }

  // Disparadores
  var TICK = 500;
  function tick() {
    if (document.visibilityState !== 'visible') return;
    elapsed += TICK;
    if (elapsed >= delay) show(false);
  }
  function onExit(e) { if (!e.relatedTarget && e.clientY <= 0) show(false); }
  var desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth >= 750;
  function stopTimers() {
    if (timer) clearInterval(timer); timer = null;
    document.removeEventListener('mouseout', onExit);
  }
  timer = setInterval(tick, TICK);
  if (desktop) setTimeout(function () { if (!open) document.addEventListener('mouseout', onExit); }, 4000); // no en el primer instante
})();
